import StudioAssessmentBenchmark from "@home/pages/studio/studioAssessment/components/StudioAssessmentBenchmark";
import StudioAssessmentCommonService from "@home/pages/studio/studioAssessment/components/StudioAssessmentCommonService";
import StudioAssessmentRadarChart from "@home/pages/studio/studioAssessment/components/StudioAssessmentRadarChart";
import StudioAssessnebtTableCard from "@home/pages/studio/studioAssessment/components/StudioAssessnebtTableCard";



export default {
  StudioAssessmentRadarChart,
  StudioAssessmentCommonService,
  StudioAssessmentBenchmark,
  StudioAssessnebtTableCard
};